import * as localForage from 'localforage';

import { createStore } from '@ngneat/elf';
import { withActiveId, withActiveIds, withEntities } from '@ngneat/elf-entities';
import {
    createRequestsCacheOperator, createRequestsStatusOperator, initializeAsPending,
    withRequestsCache, withRequestsStatus
} from '@ngneat/elf-requests';
import { persistState } from '@shared/third-party/persist-state/persist-state';

import { Reservation } from './reservation.interface';

export const store = createStore(
	{ name: 'reservations' },
	withEntities<Reservation, 'reservation_id'>({ idKey: 'reservation_id' }),
	withRequestsStatus<`reservations` | `reservation-${string}`>(
		initializeAsPending('reservations')
	),
	withRequestsCache<`reservations` | `reservation-${string}`>(),
	withActiveId(),
	withActiveIds()
);
export const trackReservationsRequestsStatus = createRequestsStatusOperator(store);
export const persist = persistState(store, {
	key: 'reservations',
	storage: localForage,
});
export const skipWhileReservationsCached = createRequestsCacheOperator(store);
